export default "__VITE_ASSET__BpmeD6FN__"